import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';

import { ShareDataView } from '../../components/ShareDataView/ShareDataView';
import {
  IForwardMessageQuotePopupProps,
  useForwardMessageQuotePresenter,
} from './ForwardMessageQuotePopup.presenter';

export const ForwardMessageQuotePopup: FC<ICommonPopupsProps<IForwardMessageQuotePopupProps>> =
  observer((props) => {
    const { t } = useTranslation();
    const presenter = useForwardMessageQuotePresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        isOpened={presenter.isAvailableToShow}
        title={t('chat_choose_another_chat_for_quote_header')}
        onClose={presenter.onClose}
      >
        <ShareDataView onChangeSelection={presenter.onGroupClick} />
      </Popup>
    );
  });
